import { render, staticRenderFns } from "./DictionaryFields.vue?vue&type=template&id=503b4458&scoped=true&"
import script from "./DictionaryFields.vue?vue&type=script&lang=js&"
export * from "./DictionaryFields.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryFields.vue?vue&type=style&index=0&id=503b4458&scoped=true&lang=scss&"
import style1 from "./DictionaryFields.vue?vue&type=style&index=1&id=503b4458&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503b4458",
  null
  
)

export default component.exports